export default "<div class=\"br-loading\">Loading…</div>\n"